import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from '@shared/models/iuser.model';
import { UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { AssignTicket, HelpTicket } from '@shared/models/help-ticket.model';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'miq-assign',
  templateUrl: './assign.component.html',
  styleUrls: ['./assign.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AssignComponent implements OnInit, OnDestroy {
  public searchControl = new UntypedFormControl();
  public usersList: IUser[];
  public filteredList: IUser[];
  public userInfo: IUser;
  public initials: string;
  public color: string;
  public searchText: string;
  public ticketInfo: HelpTicket;
  public assignTo: AssignTicket;

  constructor(
    public dialogRef: MatDialogRef<AssignComponent>,
    @Inject(MAT_DIALOG_DATA) public InjectedData: any,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.usersList = this.InjectedData.users;
    this.filteredList = this.usersList;
    this.userInfo = this.InjectedData.userInfo;
    this.ticketInfo = this.InjectedData.ticketInfo;
    this.assignTo = {
      ticketIds: [this.ticketInfo.id],
      assignToIds: [],
      updateBy: this.userInfo.emailAddress,
    };
    this.ticketInfo.assignedTo.forEach(user => this.assignTo.assignToIds.push(user.key));
  }

  public assignToUsers(): void {
    this.sharedService
      .assignTickets(this.assignTo)
      .pipe(take(1))
      .subscribe(_result => {
        this.dialogRef.close({ ticketInfo: this.ticketInfo });
      });
  }

  public selectUser({ checked, user }): void {
    if (checked) {
      this.addUser(user);
    } else {
      this.removeUser(user);
    }
  }

  public addUser(user): void {
    this.assignTo.assignToIds.push(user.id);
  }

  public removeUser(user): void {
    this.assignTo.assignToIds = this.assignTo.assignToIds.filter(id => id !== user.id);
  }

  public closePopUp(): void {
    this.dialogRef.close();
  }

  public isAssigned(user): boolean {
    return this.ticketInfo.assignedTo.some(assignedUser => assignedUser.key === user.id);
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
